import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    uid:'',
    account:'',
    isAdmin:'',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_UID: (state, uid) => {
      state.uid = uid
    },
    SET_ACCOUNT: (state, account) => {
      state.account = account
    },
    SET_ISADMIN: (state, isAdmin) => {
      state.isAdmin = isAdmin
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login({user_account:username, user_password:userInfo.password}).then(response => {
          const data = response.data
          const tokenStr = data.ukey
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          commit('SET_NAME', data.user_nickname)
          commit('SET_AVATAR', data.user_avator)
          commit('SET_UID',data.user_id)
          commit('SET_ACCOUNT',data.user_account)
          commit('SET_ISADMIN',data.user_is_admin)  //1管理员 0商家
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取菜单
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        // getInfo().then(response => {
        let response =
          {
            "code":200,
            "message":"操作成功",
            "data":{
              "roles":[
                "超级管理员"
              ],
              "icon":"http://macro-oss.oss-cn-shenzhen.aliyuncs.com/mall/images/20180607/timg.jpg",
              "menus":[
                {
                  "id":21,
                  "parentId":0,
                  "createTime":"2020-02-07T08:29:13.000+00:00",
                  "title":"权限",
                  "level":0,
                  "sort":0,
                  "name":"ums",
                  "icon":"ums",
                  "hidden":0
                },
                {
                  "id":22,
                  "parentId":21,
                  "createTime":"2020-02-07T08:29:51.000+00:00",
                  "title":"用户列表",
                  "level":1,
                  "sort":0,
                  "name":"admin",
                  "icon":"ums-admin",
                  "hidden":0
                },
                {
                  "id":23,
                  "parentId":21,
                  "createTime":"2020-02-07T08:30:13.000+00:00",
                  "title":"角色列表",
                  "level":1,
                  "sort":0,
                  "name":"role",
                  "icon":"ums-role",
                  "hidden":0
                },
                // {
                //   "id":24,
                //   "parentId":21,
                //   "createTime":"2020-02-07T08:30:53.000+00:00",
                //   "title":"菜单列表",
                //   "level":1,
                //   "sort":0,
                //   "name":"menu",
                //   "icon":"ums-menu",
                //   "hidden":0
                // },
                // {
                //   "id":25,
                //   "parentId":21,
                //   "createTime":"2020-02-07T08:31:13.000+00:00",
                //   "title":"资源列表",
                //   "level":1,
                //   "sort":0,
                //   "name":"resource",
                //   "icon":"ums-resource",
                //   "hidden":0
                // },
                {
                  "id":26,
                  "parentId":0,
                  "createTime":"2020-02-02T08:54:07.000+00:00",
                  "title":"订货管理",
                  "level":0,
                  "sort":0,
                  "name":"orderManage",
                  "icon":"order",
                  "hidden":0
                },
                {
                  "id":27,
                  "parentId":26,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"订单列表",
                  "level":1,
                  "sort":0,
                  "name":"orderList",
                  "icon":"product-list",
                  "hidden":0
                },
                {
                  "id":28,
                  "parentId":26,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"订单详情",
                  "level":1,
                  "sort":0,
                  "name":"orderDetail",
                  "icon":"product-list",
                  "hidden":1
                },
                {
                  "id":29,
                  "parentId":26,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"商品管理",
                  "level":1,
                  "sort":0,
                  "name":"commodity",
                  "icon":"product-list",
                  "hidden":0
                },{
                  "id":30,
                  "parentId":26,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"商品编辑",
                  "level":1,
                  "sort":0,
                  "name":"commodityEdit",
                  "icon":"product-list",
                  "hidden":1
                },
                {
                  "id":31,
                  "parentId":0,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"运营中心",
                  "level":1,
                  "sort":0,
                  "name":"operationCenter",
                  "icon":"sms",
                  "hidden":0
                },
                {
                  "id":32,
                  "parentId":31,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"品牌管理",
                  "level":1,
                  "sort":0,
                  "name":"operationList",
                  "icon":"sms-hot",
                  "hidden":0
                },
                {
                  "id":33,
                  "parentId":31,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"支付设置",
                  "level":1,
                  "sort":0,
                  "name":"paymentSettings",
                  "icon":"sms-coupon",
                  "hidden":0
                },
                {
                  "id":34,
                  "parentId":31,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"装修管理",
                  "level":1,
                  "sort":0,
                  "name":"renovation",
                  "icon":"sms-subject",
                  "hidden":0
                },
                {
                  "id":35,
                  "parentId":31,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"销售分析",
                  "level":1,
                  "sort":0,
                  "name":"salesAnalysis",
                  "icon":"sms-subject",
                  "hidden":1
                },
                {
                  "id":45,
                  "parentId":31,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"类目管理",
                  "level":1,
                  "sort":0,
                  "name":"categoryManagement",
                  "icon":"sms-subject",
                  "hidden":1
                },
                {
                  "id":49,
                  "parentId":31,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"类目编辑",
                  "level":1,
                  "sort":0,
                  "name":"categoryEdit",
                  "icon":"sms-subject",
                  "hidden":1
                },
                {
                  "id":50,
                  "parentId":31,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"装修编辑",
                  "level":1,
                  "sort":0,
                  "name":"renovationEdit",
                  "icon":"sms-subject",
                  "hidden":1
                },
                {
                  "id":36,
                  "parentId":0,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"渠道中心",
                  "level":0,
                  "sort":0,
                  "name":"channelCenter",
                  "icon":"sms",
                  "hidden":0
                },
                {
                  "id":37,
                  "parentId":36,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"客户列表",
                  "level":1,
                  "sort":0,
                  "name":"channelList",
                  "icon":"sms-ad",
                  "hidden":0
                },
                {
                  "id":38,
                  "parentId":36,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"新增/编辑客户",
                  "level":1,
                  "sort":0,
                  "name":"customerEditor",
                  "icon":"sms-ad",
                  "hidden":1
                },
                {
                  "id":39,
                  "parentId":36,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"客户详情",
                  "level":2,
                  "sort":0,
                  "name":"customerDetail",
                  "icon":"sms-ad",
                  "hidden":1
                },{
                  "id":40,
                  "parentId":36,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"审核",
                  "level":2,
                  "sort":0,
                  "name":"review",
                  "icon":"sms-ad",
                  "hidden":1
                },{
                  "id":41,
                  "parentId":26,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"发货",
                  "level":1,
                  "sort":0,
                  "name":"ship",
                  "icon":"product-list",
                  "hidden":1
                },{
                  "id":42,
                  "parentId":26,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"修改价格",
                  "level":1,
                  "sort":0,
                  "name":"modifyPrice",
                  "icon":"product-list",
                  "hidden":1
                },{
                  "id":43,
                  "parentId":26,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"售后",
                  "level":1,
                  "sort":0,
                  "name":"afterSale",
                  "icon":"product-list",
                  "hidden":1
                },{
                  "id":44,
                  "parentId":26,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"新增订单",
                  "level":1,
                  "sort":0,
                  "name":"addOrder",
                  "icon":"product-list",
                  "hidden":0
                },{
                  "id":45,
                  "parentId":0,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"库存管理",
                  "level":1,
                  "sort":0,
                  "name":"stockManage",
                  "icon":"product-list",
                  "hidden":0
                },{
                  "id":46,
                  "parentId":45,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"款式操作",
                  "level":1,
                  "sort":0,
                  "name":"stockList",
                  "icon":"product-list",
                  "hidden":0
                },{
                  "id":47,
                  "parentId":45,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"备货管理",
                  "level":1,
                  "sort":0,
                  "name":"stockupManage",
                  "icon":"product-list",
                  "hidden":0
                },{
                  "id":48,
                  "parentId":45,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"备货新增/编辑",
                  "level":1,
                  "sort":0,
                  "name":"stockupAdd",
                  "icon":"product-list",
                  "hidden":1
                },{
                  "id":49,
                  "parentId":26,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"售后订单列表",
                  "level":1,
                  "sort":0,
                  "name":"afterSellList",
                  "icon":"product-list",
                  "hidden":0
                },{
                  "id":50,
                  "parentId":45,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"款式库存管理",
                  "level":1,
                  "sort":0,
                  "name":"stockListV2",
                  "icon":"product-list",
                  "hidden":0
                },{
                  "id":51,
                  "parentId":45,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"库存管理/编辑",
                  "level":1,
                  "sort":0,
                  "name":"stockStoreAdd",
                  "icon":"product-list",
                  "hidden":1
                },
                {
                  "id":52,
                  "parentId":21,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"清除缓存",
                  "level":1,
                  "sort":0,
                  "name":"cache",
                  "icon":"ums",
                  "hidden":0
                },
                {
                  "id":53,
                  "parentId":31,
                  "createTime":"2020-02-02T08:55:18.000+00:00",
                  "title":"搜索设置",
                  "level":1,
                  "sort":0,
                  "name":"hot",
                  "icon":"sms-hot",
                  "hidden":0
                },
              ],
              "username":"admin"
            }
          }
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          // commit('SET_NAME', data.username)
          // commit('SET_AVATAR', data.icon)
          resolve(response)
        // }).catch(error => {
        //   reject(error)
        // })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js